interface IAppErrorContext {
  scope: string;
  error?: unknown;
  metadata?: Record<string, unknown>;
}

const emitAppEvent = (eventName: string, detail: IAppErrorContext): void => {
  if (typeof window === "undefined" || typeof CustomEvent === "undefined") {
    return;
  }

  window.dispatchEvent(new CustomEvent(eventName, { detail }));
};

export const reportAppError = ({
  scope,
  error,
  metadata,
}: IAppErrorContext): void => {
  console.error(`[${scope}]`, error, metadata);
  emitAppEvent("genesys-chatbot:error", { scope, error, metadata });
};

export const reportAppWarning = ({
  scope,
  error,
  metadata,
}: IAppErrorContext): void => {
  console.warn(`[${scope}]`, error, metadata);
  emitAppEvent("genesys-chatbot:warning", { scope, error, metadata });
};
